export default "__VITE_PUBLIC_ASSET__676be578__"